
    import { Options, Vue } from 'vue-class-component';
    import Calendar from '../components/Calendar.vue'

    @Options({
        // props: {
        //   msg: String
        // }

        components: {
            Calendar
        }
    })

    export default class Sidebar extends Vue {
        // msg!: string
    }
